import { Flex, Text, Button } from "@chakra-ui/react";
import { HeroMaskBlackFridayIcon } from "../../components/icons/blackFriday/HeroMaskBlackFridayIcon";
import { useState, useEffect } from "react";
import { t } from "i18next";

export function UltimateXmenBundleHero({
  heroRef,
  onGetDealClick,
}: {
  heroRef?: React.RefObject<HTMLDivElement>;
  onGetDealClick?: () => void;
}) {
  const firstBreakpoint = 744;
  const secondBreakpoint = 1100;

  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 0,
  );

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const overFirstBreakpoint = windowWidth >= firstBreakpoint;
  const overSecondBreakpoint = windowWidth >= secondBreakpoint;

  const getDesktopBackgroundImage = () => {
    if (overSecondBreakpoint) {
      return `url(${window.gc.global.assets_url}/static/images/web-ui/xmen-bundle/xmen_bundle_hero_lrg.png)`;
    } else if (overFirstBreakpoint) {
      return `url(${window.gc.global.assets_url}/static/images/web-ui/xmen-bundle/xmen_bundle_hero_sml.png)`;
    } else {
      return `url(${window.gc.global.assets_url}/static/images/web-ui/xmen-bundle/xmen_bundle_hero_mob_xsml.png)`;
    }
  };

  const maskWidth = "1440px";

  if (windowWidth <= secondBreakpoint) {
    return (
      <Flex
        ref={heroRef}
        maxWidth="100%"
        width="fit-content"
        position="relative"
        overflow="hidden"
        justifyContent="center"
      >
        <Flex
          maxWidth="100%"
          id="gray-background"
          position="relative"
          marginBottom="24px"
          bg="transparent.black.10"
          style={{
            maskImage: `url(${window.gc.global.assets_url}/static/images/web-ui/valkyrae/hero_mask_v2.svg)`,
            maskSize: "cover",
            maskPosition: "73% -130px",
            maskRepeat: "no-repeat",
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundBlendMode: "difference",
          }}
        >
          <Flex
            width="100%"
            position="relative"
            minHeight="400px"
            style={{
              maskImage: `url(${window.gc.global.assets_url}/static/images/web-ui/valkyrae/hero_mask_v2.svg)`,
              maskSize: "cover",
              maskPosition: "74% -142px",
              maskRepeat: "no-repeat",
              backgroundSize: "contain",
              backgroundPosition: "center calc(100% - 10px)",
              backgroundRepeat: "no-repeat",
              backgroundBlendMode: "difference",
            }}
          >
            <Flex
              width="100vw"
              height="fit-content"
              minHeight={overFirstBreakpoint ? "730px" : "550px"}
              marginBottom="10px"
              style={{
                maskImage: `url(${window.gc.global.assets_url}/static/images/web-ui/valkyrae/hero_mask_v2.svg)`,
                backgroundImage: getDesktopBackgroundImage(),
                maskSize: "cover",
                maskPosition: "calc(75%) -80px",
                maskRepeat: "no-repeat",
                backgroundSize: "cover",

                backgroundRepeat: "no-repeat",
                backgroundBlendMode: "overlay",
                ...(overFirstBreakpoint && !overSecondBreakpoint
                  ? { backgroundPosition: "center -18px" }
                  : { backgroundPosition: "center -70px" }),
              }}
              flexDirection="column"
            >
              <Flex
                height="530px"
                flexDirection="column"
                alignItems="center"
                gap="24px"
                justifyContent="center"
                pt={
                  overFirstBreakpoint && !overSecondBreakpoint
                    ? "400px"
                    : "90px"
                }
              >
                <Text
                  color="neutral.100"
                  textAlign="center"
                  fontFamily="Roboto"
                  fontSize="20px"
                  fontStyle="normal"
                  fontWeight="500"
                  lineHeight="120%"
                  width="300px"
                >
                  {t("screens.ultimateXmenBundle.getAYearOfGlobalComix")}
                </Text>
                <Button
                  width="223px"
                  height="48px"
                  minHeight="48px"
                  borderRadius="20px"
                  boxShadow="0 8px 12px 0 rgba(0, 0, 0, 0.20)"
                  background="#B89132"
                  color="#FFF"
                  fontWeight="600"
                  fontSize="16px"
                  px="24px"
                  py="12px"
                  onClick={onGetDealClick}
                  _hover={{
                    background:
                      "linear-gradient(90deg, #E0E0E0 0%, #FFDABA 100%)",
                    boxShadow: "0 10px 16px 0 rgba(0, 0, 0, 0.25)",
                  }}
                >
                  {t("screens.ultimateXmenBundle.subscribe")}
                </Button>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
        <Flex
          position="absolute"
          bottom="129px"
          left="-19%"
          width="130%"
          pointerEvents="none"
        >
          <svg
            width="100%"
            height="auto"
            viewBox="0 0 1526 595"
            preserveAspectRatio="xMidYMid meet"
          >
            <path
              d="M1525.16 98.7881C1525.16 114.791 1520.17 130.397 1510.89 143.433L1212.95 561.784C1196.79 584.475 1169.63 596.661 1141.94 593.647L78.1797 477.873C39.8218 473.698 10.484 441.765 9.56836 403.191L0 0H1.00098L10.5684 403.167C11.4719 441.24 40.4284 472.758 78.2881 476.879L1142.04 592.653C1169.38 595.628 1196.19 583.6 1212.14 561.204L1510.07 142.853C1519.24 129.986 1524.16 114.583 1524.16 98.7881V0H1525.16V98.7881Z"
              fill="transparent"
              stroke="rgba(255, 255, 255, 0.16)"
              strokeWidth="1px"
            />
          </svg>
        </Flex>
      </Flex>
    );
  }

  return (
    <Flex
      ref={heroRef}
      width={maskWidth}
      position="relative"
      pr="32px"
      minHeight="700px"
      style={{
        maskImage: `url(${window.gc.global.assets_url}/static/images/web-ui/valkyrae/hero_mask_v2.svg)`,
        maskSize: "cover",
        maskPosition: "0% -70px",
        maskRepeat: "no-repeat",
      }}
    >
      <HeroMaskBlackFridayIcon
        position="absolute"
        top="-72px"
        left="-9px"
        width="100%"
        height="100%"
        color="transparent"
        strokeWidth="1px"
        stroke="rgba(255, 255, 255, 0.16)"
      />
      <Flex
        maxWidth="100%"
        id="gray-background"
        position="relative"
        px="10px"
        marginBottom="24px"
        bg="transparent.black.10"
        style={{
          maskImage: `url(${window.gc.global.assets_url}/static/images/web-ui/valkyrae/hero_mask_v2.svg)`,
          maskSize: "cover",
          maskPosition: "0% -70px",
          maskRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundBlendMode: "difference",
        }}
      >
        <Flex
          position="relative"
          id="black-background"
          width="100%"
          maxWidth={maskWidth}
          height="fit-content"
          minHeight="600px"
          bg="#141414"
          style={{
            maskImage: `url(${window.gc.global.assets_url}/static/images/web-ui/valkyrae/hero_mask_v2.svg)`,
            maskSize: "cover",
            maskPosition: "0% -75px",
            maskRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundImage: getDesktopBackgroundImage(),
            backgroundPosition: "100% -40px",
            backgroundRepeat: "no-repeat",
            backgroundBlendMode: "screen",
          }}
          flexDirection="column"
        >
          <Flex
            height="700px"
            width={maskWidth}
            flexDirection="column"
            alignItems="center"
            gap="24px"
          >
            <Text
              position="absolute"
              left="54%"
              top="53%"
              color="neutral.100"
              textAlign="center"
              fontFamily="Roboto"
              fontSize="24px"
              fontStyle="normal"
              fontWeight="500"
              lineHeight="120%"
              width="354px"
            >
              {t("screens.ultimateXmenBundle.getAYearOfGlobalComix")}
            </Text>
            <Button
              position="absolute"
              width="223px"
              height="48px"
              minHeight="48px"
              left="58%"
              top="calc(55% + 100px)"
              borderRadius="20px"
              boxShadow="0 8px 12px 0 rgba(0, 0, 0, 0.20)"
              background="#B89132"
              color="#FFF"
              fontWeight="600"
              fontSize="16px"
              px="24px"
              py="12px"
              onClick={onGetDealClick}
              _hover={{
                background: "linear-gradient(90deg, #E0E0E0 0%, #FFDABA 100%)",
                boxShadow: "0 10px 16px 0 rgba(0, 0, 0, 0.25)",
              }}
            >
              {t("screens.ultimateXmenBundle.subscribe")}
            </Button>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
}
